import { Context } from '@nuxt/types'
import {
  GetServerCookie,
  LinkedBroadcasterCookie,
} from '~/assets/ts/utils/cookies'
import { CanEditPage } from '~/assets/ts/utils/dashboard'
import { DashboardError } from '~/components/dashboard/layout/Error.vue'
import { PromiseAll } from '~/assets/ts/utils/misc'
import { SeriesApi } from '~/apiclient/apiseries'

export default async function (context: Context) {
  const store = context.store
  const seriesID = context.params.seriesID
  const broadcasterID = GetServerCookie(LinkedBroadcasterCookie, context)

  await PromiseAll([
    await store.dispatch('dashboard/fetchBroadcasterApiKey', {
      broadcasterID,
    }),
    await store.dispatch('dashboard/fetchSeries', {
      seriesID,
    }),
  ])

  const contents = store.getters['dashboard/series'] as SeriesApi | undefined

  if (contents) {
    CanEditPage(context, broadcasterID)
  } else {
    context.error({
      statusCode: 404,
      message: DashboardError.Series,
    })
  }
}
